<h2>Deposits</h2>
<div class="flex flex-1 flex-row">
	<div class="w-1/2">
		<div class="mr-5 mt-5">
			<!--			<app-checkbox label="Pay from trust account" [(ngModel)]="adjustment.fromTrust"></app-checkbox>-->
			<div class="deposit-list" #depositList>
				<ng-container
					*ngFor="
						let deposit of adjustment?.deposits;
						trackBy: depositCompoundIndex;
						let i = index
					"
				>
					<app-container
						*ngIf="deposit"
						type="dark"
						title="Deposit {{ i + 1 }}"
						class="mt-3"
					>
						<div header *ngIf="adjustment.deposits.length > 1">
							<app-anchor (click)="removeDeposit(i)">
								<app-icon icon="delete" class="mr-2"></app-icon>Remove
							</app-anchor>
						</div>
						<app-date-picker
							label="Date"
							name="date"
							[(ngModel)]="deposit.date"
							(ngModelChange)="changed()"
							maxDate="{{ closingDate }}"
							maxDateErrorLabel="Closing Date"
						></app-date-picker>
						<app-input
							type="cents"
							label="Amount"
							name="amount"
							class="mt-3"
							[startIcon]="ICON.DOLLAR"
							[(ngModel)]="deposit.amount"
							(ngModelChange)="changed()"
						></app-input>
					</app-container>
				</ng-container>
			</div>
			<div class="mt-3">
				<app-button
					btn="primary"
					[icon]="ICON.ADD"
					(click)="addDeposit()"
					size="small"
					>Add another deposit</app-button
				>
			</div>
			<div class="mt-3">
				<app-checkbox type="clear" [(ngModel)]="adjustment.details"
					>Include all details in document</app-checkbox
				>
			</div>
		</div>

		<div class="flex flex-1 justify-between mr-5 mt-5">
			<app-button
				btn="tertiary"
				class="mr-5"
				(click)="cancelModal()"
				size="small"
				>Cancel</app-button
			>
			<app-button (click)="saveModal()" size="small">Save</app-button>
		</div>
	</div>
	<div class="w-1/2 mt-8">
		<app-container type="dark" title="Details">
			<div class="flex flex-1 flex-col">
				<div class="flex justify-between items-start mb-3">
					<div>Total deposit amount</div>
					<div>{{ total * -1 | centsToDollars }}</div>
				</div>
				<div class="flex justify-end items-start mb-3">
					<div *ngIf="total >= 0">
						<strong>Credit Vendor = {{ total | centsToDollars }}</strong>
					</div>
					<div *ngIf="total < 0">
						<strong
							>Credit Purchaser = {{ total * -1 | centsToDollars }}</strong
						>
					</div>
				</div>
			</div>
		</app-container>
	</div>
</div>
